// import React, { useEffect, useRef, useState } from "react";
// import { Button, Typography, Divider, Progress } from "antd";

// const { Text, Title } = Typography;

// const CANVAS_W = 900;
// const CANVAS_H = 740;
// const CAM_W = 160;
// const CAM_H = 120;
// const GAME_TIME_LIMIT = 60000; // 60 seconds

// export default function BoxingGame() {
//   const videoRef = useRef(null);
//   const camCanvasRef = useRef(null);
//   const gameCanvasRef = useRef(null);
//   const rafRef = useRef(null);
//   const streamRef = useRef(null);
//   const runningRef = useRef(false);
//   const handModelRef = useRef(null);

//   const [running, setRunning] = useState(false);
//   const [score, setScore] = useState(0);
//   const [health, setHealth] = useState(100);
//   const [level, setLevel] = useState(1);
//   const [status, setStatus] = useState("Ready – Click Start");
//   const [combo, setCombo] = useState(0);

//   const gameRef = useRef({
//     width: CANVAS_W,
//     height: CANVAS_H,
//     player: {
//       x: 150,
//       y: CANVAS_H * 0.7,
//       health: 100,
//       maxHealth: 100,
//       blocking: false,
//     },
//     enemies: [],
//     particles: [],
//     punches: [],
//     lastEnemySpawn: 0,
//     time: 0,
//     timeLimit: GAME_TIME_LIMIT,
//     shake: { x: 0, y: 0, intensity: 0, duration: 0 },
//     gameOver: false,
//     gameWin: false,
//     combo: 0,
//     comboTimer: 0,
//   });

//   const gestureRef = useRef({
//     leftPunch: false,
//     rightPunch: false,
//     blocking: false,
//     leftHandPos: null,
//     rightHandPos: null,
//     leftPunchSpeed: 0,
//     rightPunchSpeed: 0,
//     prevLeftX: null,
//     prevRightX: null,
//   });

//   useEffect(() => {
//     loadHandTrackingModel();
//     drawInitialState();

//     return () => {
//       stopGame();
//     };
//   }, []);

//   async function loadHandTrackingModel() {
//     try {
//       const { HandLandmarker, FilesetResolver } = await import(
//         "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest"
//       );

//       const vision = await FilesetResolver.forVisionTasks(
//         "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm"
//       );

//       handModelRef.current = await HandLandmarker.createFromOptions(vision, {
//         baseOptions: {
//           modelAssetPath:
//             "https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/1/hand_landmarker.task",
//         },
//         runningMode: "VIDEO",
//         numHands: 2,
//       });

//       console.log("Hand tracking model loaded");
//     } catch (e) {
//       console.error("Failed to load hand tracking:", e);
//     }
//   }

//   function drawInitialState() {
//     if (!gameCanvasRef.current) return;
//     const ctx = gameCanvasRef.current.getContext("2d");

//     const gradient = ctx.createLinearGradient(0, 0, 0, CANVAS_H);
//     gradient.addColorStop(0, "#1a1a2e");
//     gradient.addColorStop(1, "#16213e");
//     ctx.fillStyle = gradient;
//     ctx.fillRect(0, 0, CANVAS_W, CANVAS_H);

//     drawPlayer(ctx);

//     if (!running && !gameRef.current.gameOver && !gameRef.current.gameWin) {
//       ctx.fillStyle = "#fff";
//       ctx.font = "bold 32px Arial";
//       ctx.textAlign = "center";
//       ctx.fillText("Click Start Game to begin", CANVAS_W / 2, CANVAS_H / 3);
//       ctx.font = "20px Arial";
//       ctx.fillText("Punch forward to attack!", CANVAS_W / 2, CANVAS_H / 2);
//       ctx.fillText("Raise both hands to block!", CANVAS_W / 2, CANVAS_H / 2 + 40);
//       ctx.font = "16px Arial";
//       ctx.fillText(`Survive for ${GAME_TIME_LIMIT / 1000} seconds to win!`, CANVAS_W / 2, CANVAS_H / 2 + 80);
//     }
//   }

//   function triggerShake(intensity = 5, duration = 200) {
//     const shake = gameRef.current.shake;
//     shake.intensity = intensity;
//     shake.duration = duration;
//   }

//   function detectHandGestures(video) {
//     if (!video || video.readyState < 2 || !handModelRef.current) return;

//     try {
//       const results = handModelRef.current.detectForVideo(video, performance.now());

//       const g = gestureRef.current;
//       const prevLeftX = g.prevLeftX;
//       const prevRightX = g.prevRightX;

//       g.leftHandPos = null;
//       g.rightHandPos = null;
//       g.leftPunch = false;
//       g.rightPunch = false;
//       g.leftPunchSpeed = 0;
//       g.rightPunchSpeed = 0;

//       if (results.landmarks && results.landmarks.length > 0) {
//         for (let i = 0; i < results.landmarks.length; i++) {
//           const landmarks = results.landmarks[i];
//           const handedness = results.handednesses[i][0].categoryName;

//           const wrist = landmarks[0];
//           const middleBase = landmarks[9];

//           const normalizedX = (wrist.x + middleBase.x) / 2;
//           const normalizedY = (wrist.y + middleBase.y) / 2;
          
//           // Flip the X coordinate for un-mirrored hand tracking
//           const handX = (1 - normalizedX) * CANVAS_W;
//           const handY = normalizedY * CANVAS_H;

//           const hand = { x: handX, y: handY };

//           if (handedness === "Right") {
//             // Player's Right Hand (controls right side of screen)
//             g.rightHandPos = hand;
//             if (prevRightX !== null) {
//               const speed = Math.max(0, handX - prevRightX);
//               g.rightPunchSpeed = speed;
//               if (speed > 15) {
//                 g.rightPunch = true;
//               }
//             }
//             g.prevRightX = handX;
//           } else {
//             // Player's Left Hand (controls left side of screen)
//             g.leftHandPos = hand;
//             if (prevLeftX !== null) {
//               const speed = Math.max(0, handX - prevLeftX);
//               g.leftPunchSpeed = speed;
//               if (speed > 15) {
//                 g.leftPunch = true;
//               }
//             }
//             g.prevLeftX = handX;
//           }
//         }

//         const playerY = gameRef.current.player.y;
        
//         if (g.leftHandPos && g.rightHandPos) {
//           // Block if both hands are high
//           if (g.leftHandPos.y < playerY * 0.7 && g.rightHandPos.y < playerY * 0.7) {
//             g.blocking = true;
//           } else {
//             g.blocking = false;
//           }
//         } else {
//           g.blocking = false;
//         }
//       }
//     } catch (e) {
//       console.error("Hand detection error:", e);
//     }
//   }

//   function spawnEnemy() {
//     // UPDATED HEALTH: Dramatically increased health for better visual feedback
//     const types = [
//       { color: "#ff6b6b", health: 40, damage: 10, speed: 2, points: 10, size: 35 }, 
//       { color: "#4ecdc4", health: 70, damage: 15, speed: 1.5, points: 25, size: 45 }, 
//       { color: "#ffd93d", health: 100, damage: 20, speed: 1, points: 50, size: 55 }, 
//     ];

//     const typeIndex = Math.min(Math.floor(level / 3), types.length - 1);
//     const type = types[typeIndex];
    
//     const playerY = gameRef.current.player.y;
//     // Slight randomization in Y to create depth/lanes
//     const yPos = playerY + (Math.random() - 0.5) * 60; 

//     gameRef.current.enemies.push({
//       x: CANVAS_W + 50,
//       y: yPos,
//       health: type.health,
//       maxHealth: type.health,
//       damage: type.damage,
//       speed: type.speed,
//       points: type.points,
//       color: type.color,
//       size: type.size,
//       attackCooldown: 0,
//       stunned: 0,
//     });
//   }

//   function createPunchEffect(x, y, damage) {
//     const g = gameRef.current;
//     g.punches.push({
//       x: x,
//       y: y,
//       text: `-${damage}`,
//       life: 60,
//       alpha: 1,
//     });

//     for (let i = 0; i < 8; i++) {
//       const angle = (Math.PI * 2 * i) / 8;
//       g.particles.push({
//         x: x,
//         y: y,
//         vx: Math.cos(angle) * 4,
//         vy: Math.sin(angle) * 4,
//         size: 4,
//         color: "#ffaa00",
//         life: 1,
//       });
//     }
//   }

//   function step(dt) {
//     if (!runningRef.current) return;

//     const g = gameRef.current;
//     g.time += dt;

//     // Check for Win condition
//     if (g.time >= g.timeLimit) {
//       runningRef.current = false;
//       setRunning(false);
//       g.gameWin = true;
//       setStatus("VICTORY! Click Start to play again.");
//       return;
//     }

//     if (g.shake.duration > 0) {
//       g.shake.duration -= dt;
//       const intensity = g.shake.intensity * (g.shake.duration / 200);
//       g.shake.x = (Math.random() - 0.5) * intensity * 2;
//       g.shake.y = (Math.random() - 0.5) * intensity * 2;
//     } else {
//       g.shake.x = 0;
//       g.shake.y = 0;
//       g.shake.intensity = 0;
//     }

//     const spawnDelay = Math.max(1500, 3000 - level * 100);
//     if (g.time - g.lastEnemySpawn > spawnDelay) {
//       spawnEnemy();
//       g.lastEnemySpawn = g.time;
//     }

//     if (g.comboTimer > 0) {
//       g.comboTimer -= dt;
//       if (g.comboTimer <= 0) {
//         g.combo = 0;
//         setCombo(0);
//       }
//     }

//     const player = g.player;
//     player.blocking = gestureRef.current.blocking;

//     const { leftPunch, rightPunch, leftPunchSpeed, rightPunchSpeed } = gestureRef.current;
//     const dt_factor = dt / 16.6;

//     for (let i = g.enemies.length - 1; i >= 0; i--) {
//       const enemy = g.enemies[i];

//       if (enemy.stunned > 0) {
//         enemy.stunned -= dt;
//         continue;
//       }

//       const targetX = player.x + 50; 

//       if (enemy.x > targetX) {
//         enemy.x -= enemy.speed * dt_factor;
//       } else {
//         // Attack logic when enemy reaches the player
//         enemy.attackCooldown -= dt;
//         if (enemy.attackCooldown <= 0) {
//           if (!player.blocking) {
//             player.health -= enemy.damage;
//             setHealth(Math.max(0, player.health));
//             triggerShake(10, 200);

//             if (player.health <= 0) {
//               runningRef.current = false;
//               setRunning(false);
//               g.gameOver = true;
//               setStatus("Game Over – Click Start");
//             }
//           } else {
//             triggerShake(5, 100);
//           }
//           enemy.attackCooldown = 1500;
//         }
//       }

//       const punchDist = 150; 
      
//       if (
//         (leftPunch || rightPunch) &&
//         Math.abs(enemy.y - player.y) < enemy.size * 1.5 && 
//         enemy.x < player.x + punchDist &&
//         enemy.x > player.x
//       ) {
//         // Damage calculation logic remains the same
//         const speed = leftPunch ? leftPunchSpeed : rightPunchSpeed;
//         const damage = Math.max(1, Math.ceil(speed / 3));

//         enemy.health -= damage;
//         enemy.stunned = 200; 
//         createPunchEffect(enemy.x, enemy.y, damage);
//         triggerShake(3, 100);

//         if (enemy.health <= 0) {
//           setScore((s) => {
//             const newScore = s + enemy.points;
//             const newLevel = Math.floor(newScore / 100) + 1;
//             if (newLevel > level) {
//               setLevel(newLevel);
//             }
//             return newScore;
//           });

//           g.combo++;
//           g.comboTimer = 2000;
//           setCombo(g.combo);
//           g.enemies.splice(i, 1);
//         }
//       }
//     }

//     for (let i = g.particles.length - 1; i >= 0; i--) {
//       const p = g.particles[i];
//       p.x += p.vx;
//       p.y += p.vy;
//       p.life -= 0.02;
//       if (p.life <= 0) {
//         g.particles.splice(i, 1);
//       }
//     }

//     for (let i = g.punches.length - 1; i >= 0; i--) {
//       const punch = g.punches[i];
//       punch.y -= 1;
//       punch.life -= 1;
//       punch.alpha = punch.life / 60;
//       if (punch.life <= 0) {
//         g.punches.splice(i, 1);
//       }
//     }
//   }

//   function drawPlayer(ctx) {
//     const player = gameRef.current.player;

//     ctx.fillStyle = player.blocking ? "#4ECDC4" : "#7ee787";
//     ctx.beginPath();
//     ctx.arc(player.x, player.y, 40, 0, Math.PI * 2);
//     ctx.fill();

//     ctx.fillStyle = "#000";
//     ctx.beginPath();
//     ctx.arc(player.x - 10, player.y - 10, 5, 0, Math.PI * 2);
//     ctx.arc(player.x + 10, player.y - 10, 5, 0, Math.PI * 2);
//     ctx.fill();

//     if (player.blocking) {
//       ctx.strokeStyle = "#4ECDC4";
//       ctx.lineWidth = 4;
//       ctx.beginPath();
//       ctx.arc(player.x, player.y, 60, 0, Math.PI * 2);
//       ctx.stroke();
//     }

//     const barWidth = 80;
//     const barHeight = 8;
//     ctx.fillStyle = "#333";
//     ctx.fillRect(player.x - barWidth / 2, player.y - 60, barWidth, barHeight);
//     ctx.fillStyle =
//       player.health > 50 ? "#4ade80" : player.health > 25 ? "#fbbf24" : "#f87171";
//     ctx.fillRect(
//       player.x - barWidth / 2,
//       player.y - 60,
//       (barWidth * player.health) / player.maxHealth,
//       barHeight
//     );
//   }

//   function drawEnemy(ctx, enemy) {
//     // 1. Calculate Scale Factor for perspective
//     const relativeX = CANVAS_W - enemy.x;
//     const maxRelativeX = CANVAS_W - gameRef.current.player.x;
//     const scaleFactor = 0.5 + 0.5 * (relativeX / maxRelativeX); // Scales from 0.5 (far) to 1.0 (close)

//     const scaledSize = enemy.size * scaleFactor;
//     const scaledBarWidth = enemy.size * 1.5 * scaleFactor;
//     const scaledBarHeight = 6 * scaleFactor;

//     if (enemy.stunned > 0) {
//       ctx.fillStyle = "rgba(255, 255, 0, 0.3)";
//       ctx.beginPath();
//       ctx.arc(enemy.x, enemy.y, scaledSize + 5, 0, Math.PI * 2);
//       ctx.fill();
//     }

//     // 2. Draw Enemy Circle
//     ctx.fillStyle = enemy.color;
//     ctx.beginPath();
//     ctx.arc(enemy.x, enemy.y, scaledSize, 0, Math.PI * 2);
//     ctx.fill();

//     // 3. Draw Eyes and Mouth (Scaled)
//     ctx.fillStyle = "#000";
//     ctx.beginPath();
//     ctx.arc(enemy.x - scaledSize / 3, enemy.y - scaledSize / 4, 5 * scaleFactor, 0, Math.PI * 2);
//     ctx.arc(enemy.x + scaledSize / 3, enemy.y - scaledSize / 4, 5 * scaleFactor, 0, Math.PI * 2);
//     ctx.fill();

//     ctx.strokeStyle = "#000";
//     ctx.lineWidth = 3 * scaleFactor;
//     ctx.beginPath();
//     ctx.arc(enemy.x, enemy.y + scaledSize / 6, scaledSize / 4, 0, Math.PI);
//     ctx.stroke();

//     // 4. Draw Health Bar (Scaled)
//     const barY = enemy.y - scaledSize - 10;
//     ctx.fillStyle = "#333";
//     ctx.fillRect(enemy.x - scaledBarWidth / 2, barY, scaledBarWidth, scaledBarHeight);
//     ctx.fillStyle = "#f87171";
//     ctx.fillRect(
//       enemy.x - scaledBarWidth / 2,
//       barY,
//       (scaledBarWidth * enemy.health) / enemy.maxHealth,
//       scaledBarHeight
//     );
//   }

//   function draw() {
//     const ctx = gameCanvasRef.current?.getContext("2d");
//     if (!ctx) return;

//     ctx.save();
//     ctx.translate(gameRef.current.shake.x, gameRef.current.shake.y);

//     const gradient = ctx.createLinearGradient(0, 0, 0, CANVAS_H);
//     gradient.addColorStop(0, "#1a1a2e");
//     gradient.addColorStop(1, "#16213e");
//     ctx.fillStyle = gradient;
//     ctx.fillRect(0, 0, CANVAS_W, CANVAS_H);

//     const g = gameRef.current;
//     const ges = gestureRef.current;

//     // Draw the "floor"
//     ctx.strokeStyle = "#444";
//     ctx.lineWidth = 2;
//     ctx.setLineDash([10, 10]);
//     ctx.beginPath();
//     ctx.moveTo(0, g.player.y + 40);
//     ctx.lineTo(CANVAS_W, g.player.y + 40);
//     ctx.stroke();
//     ctx.setLineDash([]);

//     // Draw particles, punches, enemies, and player
//     g.particles.forEach((p) => {
//       ctx.fillStyle = p.color;
//       ctx.globalAlpha = p.life;
//       ctx.beginPath();
//       ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
//       ctx.fill();
//       ctx.globalAlpha = 1;
//     });

//     g.punches.forEach((punch) => {
//       ctx.fillStyle = `rgba(255, 170, 0, ${punch.alpha})`;
//       ctx.font = "bold 24px Arial";
//       ctx.textAlign = "center";
//       ctx.fillText(punch.text, punch.x, punch.y);
//     });

//     g.enemies.forEach((enemy) => drawEnemy(ctx, enemy));
//     drawPlayer(ctx);

//     // Draw Time Remaining
//     if (runningRef.current) {
//         const timeRemaining = Math.max(0, (g.timeLimit - g.time) / 1000);
//         ctx.fillStyle = timeRemaining < 10 ? "#f87171" : "#fff";
//         ctx.font = "bold 28px Arial";
//         ctx.textAlign = "right";
//         ctx.fillText(`Time: ${timeRemaining.toFixed(1)}s`, CANVAS_W - 20, 40);
//     }


//     // Visual feedback for hand positions
//     if (ges.leftHandPos) {
//       ctx.fillStyle = "rgba(126, 231, 135, 0.5)";
//       ctx.beginPath();
//       ctx.arc(ges.leftHandPos.x, ges.leftHandPos.y, 20, 0, Math.PI * 2);
//       ctx.fill();
//     }
//     if (ges.rightHandPos) {
//       ctx.fillStyle = "rgba(78, 205, 196, 0.5)";
//       ctx.beginPath();
//       ctx.arc(ges.rightHandPos.x, ges.rightHandPos.y, 20, 0, Math.PI * 2);
//       ctx.fill();
//     }
    
//     // Game Over / Win Screens
//     if (g.gameOver) {
//       ctx.fillStyle = "rgba(0, 0, 0, 0.8)";
//       ctx.fillRect(0, 0, CANVAS_W, CANVAS_H);

//       ctx.fillStyle = "#fff";
//       ctx.font = "bold 64px Arial";
//       ctx.textAlign = "center";
//       ctx.fillText("K.O.!", CANVAS_W / 2, CANVAS_H / 3);

//       ctx.font = "32px Arial";
//       ctx.fillText(`Final Score: ${score}`, CANVAS_W / 2, CANVAS_H / 2);
//       ctx.font = "24px Arial";
//       ctx.fillText("Click Start to fight again", CANVAS_W / 2, CANVAS_H / 2 + 50);
//     } else if (g.gameWin) {
//         ctx.fillStyle = "rgba(26, 26, 46, 0.9)";
//         ctx.fillRect(0, 0, CANVAS_W, CANVAS_H);

//         ctx.fillStyle = "#4ade80";
//         ctx.font = "bold 64px Arial";
//         ctx.textAlign = "center";
//         ctx.fillText("VICTORY!", CANVAS_W / 2, CANVAS_H / 3);

//         ctx.fillStyle = "#fff";
//         ctx.font = "32px Arial";
//         ctx.fillText(`Final Score: ${score}`, CANVAS_W / 2, CANVAS_H / 2);
//         ctx.font = "24px Arial";
//         ctx.fillText("You survived the round!", CANVAS_W / 2, CANVAS_H / 2 + 50);
//     }

//     ctx.restore();
//   }

//   function gameLoop(time) {
//     const dt = time - (gameLoop.last || time);
//     gameLoop.last = time;

//     if (videoRef.current && videoRef.current.readyState >= 2) {
//       detectHandGestures(videoRef.current);
//     }

//     drawCameraPreview();

//     if (runningRef.current) {
//       step(dt);
//     }

//     draw();

//     if (runningRef.current || gameRef.current.gameOver || gameRef.current.gameWin) {
//       rafRef.current = requestAnimationFrame(gameLoop);
//     }
//   }

//   function drawCameraPreview() {
//     if (!camCanvasRef.current || !videoRef.current || videoRef.current.readyState < 2) {
//       return;
//     }

//     try {
//       const ctx = camCanvasRef.current.getContext("2d");
//       ctx.fillStyle = "#000";
//       ctx.fillRect(0, 0, CAM_W, CAM_H);

//       ctx.save();
//       ctx.scale(-1, 1);
//       ctx.drawImage(videoRef.current, -CAM_W, 0, CAM_W, CAM_H);
//       ctx.restore();

//       const ges = gestureRef.current;
      
//       if (ges.leftHandPos) {
//         const unMirroredX = ges.leftHandPos.x; 
//         const mirroredX = CAM_W - (unMirroredX / CANVAS_W) * CAM_W;
//         const y = (ges.leftHandPos.y / CANVAS_H) * CAM_H;
        
//         ctx.fillStyle = "rgba(126, 231, 135, 0.6)";
//         ctx.beginPath();
//         ctx.arc(mirroredX, y, 8, 0, Math.PI * 2);
//         ctx.fill();
//       }

//       if (ges.rightHandPos) {
//         const unMirroredX = ges.rightHandPos.x;
//         const mirroredX = CAM_W - (unMirroredX / CANVAS_W) * CAM_W;
//         const y = (ges.rightHandPos.y / CANVAS_H) * CAM_H;
        
//         ctx.fillStyle = "rgba(78, 205, 196, 0.6)";
//         ctx.beginPath();
//         ctx.arc(mirroredX, y, 8, 0, Math.PI * 2);
//         ctx.fill();
//       }

//       if (ges.blocking) {
//         ctx.strokeStyle = "rgba(78, 205, 196, 1)";
//         ctx.lineWidth = 4;
//         ctx.strokeRect(0, 0, CAM_W, CAM_H);
//       }
//     } catch (e) {
//       console.error("Error drawing camera preview:", e);
//     }
//   }

//   function resetGameState() {
//     setScore(0);
//     setHealth(100);
//     setLevel(1);
//     setCombo(0);

//     gameRef.current = {
//       width: CANVAS_W,
//       height: CANVAS_H,
//       player: {
//         x: 150,
//         y: CANVAS_H * 0.7,
//         health: 100,
//         maxHealth: 100,
//         blocking: false,
//       },
//       enemies: [],
//       particles: [],
//       punches: [],
//       lastEnemySpawn: 0,
//       time: 0,
//       timeLimit: GAME_TIME_LIMIT,
//       shake: { x: 0, y: 0, intensity: 0, duration: 0 },
//       gameOver: false,
//       gameWin: false,
//       combo: 0,
//       comboTimer: 0,
//     };
//     drawInitialState();
//   }

//   async function startGame() {
//     if (runningRef.current) return;

//     resetGameState();
//     setStatus("Requesting camera access...");

//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({
//         video: {
//           width: { ideal: 640 },
//           height: { ideal: 480 },
//           facingMode: "user",
//         },
//       });

//       streamRef.current = stream;
//       setStatus("Camera acquired...");

//       if (!videoRef.current) {
//         videoRef.current = document.createElement("video");
//       }

//       videoRef.current.playsInline = true;
//       videoRef.current.muted = true;
//       videoRef.current.autoplay = true;
//       videoRef.current.srcObject = stream;

//       await new Promise((resolve) => {
//         const checkReady = () => {
//           if (videoRef.current.readyState >= 2) {
//             resolve();
//           }
//         };
//         videoRef.current.addEventListener("loadeddata", checkReady);
//         setTimeout(resolve, 5000);
//       });

//       try {
//         await videoRef.current.play();
//       } catch (e) {
//         console.log("Play error:", e);
//       }

//       await new Promise((resolve) => setTimeout(resolve, 500));

//       if (rafRef.current) {
//         cancelAnimationFrame(rafRef.current);
//       }

//       runningRef.current = true;
//       setRunning(true);

//       gameLoop.last = performance.now();
//       rafRef.current = requestAnimationFrame(gameLoop);

//       setStatus("🥊 Fight! Punch to attack!");
//     } catch (e) {
//       console.error("Camera error:", e);
//       setStatus(`Camera error: ${e.message}`);
//     }
//   }

//   function stopGame() {
//     runningRef.current = false;
//     setRunning(false);

//     if (rafRef.current) {
//       cancelAnimationFrame(rafRef.current);
//       rafRef.current = null;
//     }

//     if (streamRef.current) {
//       streamRef.current.getTracks().forEach((track) => track.stop());
//       streamRef.current = null;
//     }

//     if (videoRef.current) {
//       videoRef.current.srcObject = null;
//     }

//     setStatus("Stopped – Click Start");
//     drawInitialState();
//   }

//   return (
//     <div style={{ display: "flex", minHeight: "100vh", background: "#0f3460" }}>
//       <div style={{ width: 320, background: "#1f1f1f", padding: 16, color: "#fff" }}>
//         <Title level={3} style={{ color: "#e94560", marginTop: 0 }}>
//           🥊 Shadow Boxing RPG
//         </Title>

//         <Text
//           style={{
//             color: "#e6eef8",
//             marginBottom: 8,
//             fontSize: 13,
//             fontWeight: "bold",
//             display: "block",
//           }}
//         >
//           {status}
//         </Text>

//         <Divider style={{ margin: "16px 0", borderColor: "rgba(255,255,255,0.2)" }} />

//         <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
//           <Button
//             onClick={startGame}
//             disabled={running}
//             type="primary"
//             block
//             size="large"
//             style={{
//               fontWeight: "bold",
//               background: running ? "#555" : "#e94560",
//               borderColor: running ? "#555" : "#e94560",
//             }}
//           >
//             Start Fight
//           </Button>
//           <Button
//             onClick={stopGame}
//             disabled={!running}
//             danger
//             block
//             size="large"
//           >
//             Stop Fight
//           </Button>
//           <Button onClick={resetGameState} type="primary" block ghost size="large">
//             Reset
//           </Button>
//         </div>

//         <div style={{ marginBottom: 16 }}>
//           <Text style={{ color: "#4ade80", fontSize: 22, fontWeight: "bold", display: "block" }}>
//             Score: {score}
//           </Text>
//           <div style={{ marginTop: 8 }}>
//             <Text style={{ color: "#fff", fontSize: 14 }}>Health:</Text>
//             <Progress
//               percent={health}
//               strokeColor={health > 50 ? "#4ade80" : health > 25 ? "#fbbf24" : "#f87171"}
//               showInfo={false}
//               style={{ marginTop: 4 }}
//             />
//           </div>
//           <Text style={{ color: "#fbbf24", fontSize: 22, fontWeight: "bold", display: "block" }}>
//             Level: {level}
//           </Text>
//           <Text style={{ color: "#4ecdc4", fontSize: 22, fontWeight: "bold", display: "block" }}>
//             Combo: {combo}x
//           </Text>
//           <Text style={{ color: "#e6eef8", fontSize: 18, fontWeight: "bold", display: "block", marginTop: 8 }}>
//             Time Left: {(gameRef.current.timeLimit - gameRef.current.time) > 0 ? ((gameRef.current.timeLimit - gameRef.current.time) / 1000).toFixed(1) : '0.0'}s
//           </Text>
//         </div>

//         <Divider style={{ margin: "16px 0", borderColor: "rgba(255,255,255,0.2)" }} />

//         <div style={{ color: "#bfe7ff", fontSize: 12, marginBottom: 12, lineHeight: 1.6 }}>
//           <Title level={5} style={{ color: "#bfe7ff", marginTop: 8 }}>
//             Controls (Non-Mirrored!):
//           </Title>
//           <Text style={{ color: "#bfe7ff", display: "block" }}>
//             • Punch forward to attack
//           </Text>
//           <Text style={{ color: "#bfe7ff", display: "block" }}>
//             • Raise both hands to block
//           </Text>
//           <Text style={{ color: "#bfe7ff", display: "block" }}>
//             • Faster punches = more damage
//           </Text>
//           <Text style={{ color: "#bfe7ff", display: "block" }}>
//             • Chain attacks for combo!
//           </Text>
//         </div>

//         <Text
//           style={{
//             marginBottom: 8,
//             color: "#999",
//             fontSize: 11,
//             fontWeight: "bold",
//             display: "block",
//           }}
//         >
//           Camera Preview:
//         </Text>
//         <canvas
//           ref={camCanvasRef}
//           width={CAM_W}
//           height={CAM_H}
//           style={{
//             borderRadius: 8,
//             width: "100%",
//             background: "#000",
//             border: gestureRef.current.blocking ? "2px solid #4ecdc4" : "2px solid #333",
//           }}
//         />
//       </div>

//       <div
//         style={{
//           flex: 1,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <canvas
//           ref={gameCanvasRef}
//           width={CANVAS_W}
//           height={CANVAS_H}
//           style={{ borderRadius: 8, boxShadow: "0 8px 30px rgba(0,0,0,0.6)" }}
//         />
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import { Button, Typography, Divider, Progress } from "antd";

const { Text, Title } = Typography;

const CANVAS_W = 900;
const CANVAS_H = 740;
const CAM_W = 160;
const CAM_H = 120;
const GAME_TIME_LIMIT = 90000; // 90 seconds

export default function EnhancedBoxingGame() {
  const videoRef = useRef(null);
  const camCanvasRef = useRef(null);
  const gameCanvasRef = useRef(null);
  const rafRef = useRef(null);
  const streamRef = useRef(null);
  const runningRef = useRef(false);
  const handModelRef = useRef(null);

  const [running, setRunning] = useState(false);
  const [score, setScore] = useState(0);
  const [health, setHealth] = useState(100);
  const [level, setLevel] = useState(1);
  const [status, setStatus] = useState("Ready – Click Start");
  const [combo, setCombo] = useState(0);
  const [energy, setEnergy] = useState(0);

  const gameRef = useRef({
    width: CANVAS_W,
    height: CANVAS_H,
    player: {
      x: 150,
      y: CANVAS_H * 0.7,
      health: 100,
      maxHealth: 100,
      blocking: false,
      energy: 0,
      maxEnergy: 100,
      superPunchReady: false,
      invulnerable: 0,
    },
    enemies: [],
    particles: [],
    punches: [],
    powerups: [],
    lastEnemySpawn: 0,
    lastPowerupSpawn: 0,
    time: 0,
    timeLimit: GAME_TIME_LIMIT,
    shake: { x: 0, y: 0, intensity: 0, duration: 0 },
    gameOver: false,
    gameWin: false,
    combo: 0,
    comboTimer: 0,
    stars: [], // Background stars for parallax
    wave: 1,
    enemiesThisWave: 0,
    maxEnemiesPerWave: 5,
  });

  const gestureRef = useRef({
    leftPunch: false,
    rightPunch: false,
    blocking: false,
    leftHandPos: null,
    rightHandPos: null,
    leftPunchSpeed: 0,
    rightPunchSpeed: 0,
    prevLeftX: null,
    prevRightX: null,
    bothHandsExtended: false,
    superPunchCharged: false,
  });

  useEffect(() => {
    loadHandTrackingModel();
    initializeStars();
    drawInitialState();

    return () => {
      stopGame();
    };
  }, []);

  function initializeStars() {
    const stars = [];
    for (let i = 0; i < 100; i++) {
      stars.push({
        x: Math.random() * CANVAS_W,
        y: Math.random() * CANVAS_H,
        size: Math.random() * 2 + 0.5,
        speed: Math.random() * 0.5 + 0.1,
        opacity: Math.random() * 0.5 + 0.3,
      });
    }
    gameRef.current.stars = stars;
  }

  async function loadHandTrackingModel() {
    try {
      const { HandLandmarker, FilesetResolver } = await import(
        "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest"
      );

      const vision = await FilesetResolver.forVisionTasks(
        "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm"
      );

      handModelRef.current = await HandLandmarker.createFromOptions(vision, {
        baseOptions: {
          modelAssetPath:
            "https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/1/hand_landmarker.task",
        },
        runningMode: "VIDEO",
        numHands: 2,
      });

      console.log("Hand tracking model loaded");
    } catch (e) {
      console.error("Failed to load hand tracking:", e);
    }
  }

  function drawInitialState() {
    if (!gameCanvasRef.current) return;
    const ctx = gameCanvasRef.current.getContext("2d");

    drawBackground(ctx);
    drawPlayer(ctx);

    if (!running && !gameRef.current.gameOver && !gameRef.current.gameWin) {
      ctx.fillStyle = "rgba(0, 0, 0, 0.7)";
      ctx.fillRect(CANVAS_W / 2 - 250, CANVAS_H / 3 - 100, 500, 300);

      ctx.fillStyle = "#FFD700";
      ctx.font = "bold 36px Arial";
      ctx.textAlign = "center";
      ctx.fillText("🥊 SHADOW BOXING RPG 🥊", CANVAS_W / 2, CANVAS_H / 3 - 40);

      ctx.fillStyle = "#fff";
      ctx.font = "20px Arial";
      ctx.fillText("Punch forward to attack enemies!", CANVAS_W / 2, CANVAS_H / 3 + 20);
      ctx.fillText("Raise both hands HIGH to block!", CANVAS_W / 2, CANVAS_H / 3 + 50);
      ctx.font = "18px Arial";
      ctx.fillStyle = "#4ade80";
      ctx.fillText("Build energy for SUPER PUNCH! 💥", CANVAS_W / 2, CANVAS_H / 3 + 90);
      ctx.fillStyle = "#FFD700";
      ctx.fillText(`Survive ${GAME_TIME_LIMIT / 1000}s to win!`, CANVAS_W / 2, CANVAS_H / 3 + 120);
    }
  }

  function drawBackground(ctx) {
    // Gradient background
    const gradient = ctx.createLinearGradient(0, 0, 0, CANVAS_H);
    gradient.addColorStop(0, "#0a0e27");
    gradient.addColorStop(0.5, "#1a1a3e");
    gradient.addColorStop(1, "#16213e");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, CANVAS_W, CANVAS_H);

    // Parallax stars
    gameRef.current.stars.forEach((star) => {
      ctx.fillStyle = `rgba(255, 255, 255, ${star.opacity})`;
      ctx.beginPath();
      ctx.arc(star.x, star.y, star.size, 0, Math.PI * 2);
      ctx.fill();
    });

    // Grid floor
    ctx.strokeStyle = "rgba(100, 200, 255, 0.2)";
    ctx.lineWidth = 1;
    const playerY = gameRef.current.player.y + 40;
    for (let i = 0; i < 10; i++) {
      const y = playerY + i * 20;
      const alpha = 1 - i * 0.1;
      ctx.globalAlpha = alpha;
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(CANVAS_W, y);
      ctx.stroke();
    }
    ctx.globalAlpha = 1;
  }

  function triggerShake(intensity = 5, duration = 200) {
    const shake = gameRef.current.shake;
    shake.intensity = intensity;
    shake.duration = duration;
  }

  function detectHandGestures(video) {
    if (!video || video.readyState < 2 || !handModelRef.current) return;

    try {
      const results = handModelRef.current.detectForVideo(video, performance.now());

      const g = gestureRef.current;
      const prevLeftX = g.prevLeftX;
      const prevRightX = g.prevRightX;

      g.leftHandPos = null;
      g.rightHandPos = null;
      g.leftPunch = false;
      g.rightPunch = false;
      g.leftPunchSpeed = 0;
      g.rightPunchSpeed = 0;

      if (results.landmarks && results.landmarks.length > 0) {
        for (let i = 0; i < results.landmarks.length; i++) {
          const landmarks = results.landmarks[i];
          const handedness = results.handednesses[i][0].categoryName;

          const wrist = landmarks[0];
          const middleBase = landmarks[9];

          const normalizedX = (wrist.x + middleBase.x) / 2;
          const normalizedY = (wrist.y + middleBase.y) / 2;

          const handX = (1 - normalizedX) * CANVAS_W;
          const handY = normalizedY * CANVAS_H;

          const hand = { x: handX, y: handY };

          if (handedness === "Right") {
            g.rightHandPos = hand;
            if (prevRightX !== null) {
              const speed = Math.max(0, handX - prevRightX);
              g.rightPunchSpeed = speed;
              if (speed > 15) {
                g.rightPunch = true;
              }
            }
            g.prevRightX = handX;
          } else {
            g.leftHandPos = hand;
            if (prevLeftX !== null) {
              const speed = Math.max(0, handX - prevLeftX);
              g.leftPunchSpeed = speed;
              if (speed > 15) {
                g.leftPunch = true;
              }
            }
            g.prevLeftX = handX;
          }
        }

        const playerY = gameRef.current.player.y;

        if (g.leftHandPos && g.rightHandPos) {
          // Check for blocking (both hands high)
          if (g.leftHandPos.y < playerY * 0.7 && g.rightHandPos.y < playerY * 0.7) {
            g.blocking = true;
          } else {
            g.blocking = false;
          }

          // Check for super punch charge (both hands extended forward)
          const avgX = (g.leftHandPos.x + g.rightHandPos.x) / 2;
          if (avgX > CANVAS_W * 0.5 && Math.abs(g.leftHandPos.y - g.rightHandPos.y) < 50) {
            g.bothHandsExtended = true;
          } else {
            g.bothHandsExtended = false;
          }
        } else {
          g.blocking = false;
          g.bothHandsExtended = false;
        }
      }
    } catch (e) {
      console.error("Hand detection error:", e);
    }
  }

  function spawnEnemy() {
    const types = [
      { name: "Grunt", color: "#ff6b6b", health: 40, damage: 10, speed: 2, points: 10, size: 35, glow: "#ff0000" },
      { name: "Tank", color: "#4ecdc4", health: 80, damage: 15, speed: 1.2, points: 25, size: 50, glow: "#00ffff" },
      { name: "Speedster", color: "#ffd93d", health: 30, damage: 8, speed: 3, points: 20, size: 30, glow: "#ffff00" },
      { name: "Boss", color: "#ff44ff", health: 150, damage: 25, speed: 0.8, points: 100, size: 65, glow: "#ff00ff" },
    ];

    let typeIndex = Math.min(Math.floor(level / 3), types.length - 2);
    
    // Boss spawns every 5 waves
    if (gameRef.current.wave % 5 === 0 && gameRef.current.enemiesThisWave === 0) {
      typeIndex = 3; // Boss
    }

    const type = types[typeIndex];

    const playerY = gameRef.current.player.y;
    const yPos = playerY + (Math.random() - 0.5) * 80;

    gameRef.current.enemies.push({
      x: CANVAS_W + 50,
      y: yPos,
      health: type.health,
      maxHealth: type.health,
      damage: type.damage,
      speed: type.speed,
      points: type.points,
      color: type.color,
      size: type.size,
      glow: type.glow,
      name: type.name,
      attackCooldown: 0,
      stunned: 0,
      isDying: false,
      deathTimer: 0,
    });

    gameRef.current.enemiesThisWave++;
  }

  function spawnPowerup() {
    const types = [
      { type: "health", color: "#4ade80", emoji: "❤️", effect: "heal" },
      { type: "energy", color: "#FFD700", emoji: "⚡", effect: "energy" },
      { type: "shield", color: "#4ecdc4", emoji: "🛡️", effect: "shield" },
    ];

    const type = types[Math.floor(Math.random() * types.length)];
    const playerY = gameRef.current.player.y;

    gameRef.current.powerups.push({
      x: CANVAS_W + 50,
      y: playerY + (Math.random() - 0.5) * 100,
      type: type.type,
      color: type.color,
      emoji: type.emoji,
      effect: type.effect,
      size: 25,
      rotation: 0,
      bobOffset: Math.random() * Math.PI * 2,
    });
  }

  function createPunchEffect(x, y, damage, isSuperPunch = false) {
    const g = gameRef.current;
    g.punches.push({
      x: x,
      y: y,
      text: isSuperPunch ? `💥 -${damage} 💥` : `-${damage}`,
      life: 60,
      alpha: 1,
      size: isSuperPunch ? 32 : 24,
      color: isSuperPunch ? "#FFD700" : "#ffaa00",
    });

    const particleCount = isSuperPunch ? 20 : 8;
    const particleColor = isSuperPunch ? "#FFD700" : "#ffaa00";

    for (let i = 0; i < particleCount; i++) {
      const angle = (Math.PI * 2 * i) / particleCount;
      const speed = isSuperPunch ? 8 : 4;
      g.particles.push({
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        size: isSuperPunch ? 6 : 4,
        color: particleColor,
        life: 1,
      });
    }
  }

  function createBlockEffect(x, y) {
    const g = gameRef.current;
    for (let i = 0; i < 12; i++) {
      const angle = (Math.PI * 2 * i) / 12;
      g.particles.push({
        x: x,
        y: y,
        vx: Math.cos(angle) * 3,
        vy: Math.sin(angle) * 3,
        size: 4,
        color: "#4ecdc4",
        life: 1,
      });
    }
  }

  function step(dt) {
    if (!runningRef.current) return;

    const g = gameRef.current;
    g.time += dt;

    // Update stars parallax
    g.stars.forEach((star) => {
      star.x -= star.speed;
      if (star.x < 0) {
        star.x = CANVAS_W;
        star.y = Math.random() * CANVAS_H;
      }
    });

    // Check for Win condition
    if (g.time >= g.timeLimit) {
      runningRef.current = false;
      setRunning(false);
      g.gameWin = true;
      setStatus("🏆 VICTORY! You're a true warrior!");
      return;
    }

    if (g.shake.duration > 0) {
      g.shake.duration -= dt;
      const intensity = g.shake.intensity * (g.shake.duration / 200);
      g.shake.x = (Math.random() - 0.5) * intensity * 2;
      g.shake.y = (Math.random() - 0.5) * intensity * 2;
    } else {
      g.shake.x = 0;
      g.shake.y = 0;
      g.shake.intensity = 0;
    }

    // Wave system
    if (g.enemies.length === 0 && g.enemiesThisWave >= g.maxEnemiesPerWave) {
      g.wave++;
      g.enemiesThisWave = 0;
      g.maxEnemiesPerWave = Math.min(5 + Math.floor(g.wave / 2), 10);
      setStatus(`🌊 Wave ${g.wave}! Get ready!`);
    }

    // Spawn enemies
    const spawnDelay = Math.max(1500, 3000 - level * 100);
    if (g.time - g.lastEnemySpawn > spawnDelay && g.enemiesThisWave < g.maxEnemiesPerWave) {
      spawnEnemy();
      g.lastEnemySpawn = g.time;
    }

    // Spawn powerups
    if (g.time - g.lastPowerupSpawn > 15000 && Math.random() < 0.3) {
      spawnPowerup();
      g.lastPowerupSpawn = g.time;
    }

    if (g.comboTimer > 0) {
      g.comboTimer -= dt;
      if (g.comboTimer <= 0) {
        g.combo = 0;
        setCombo(0);
      }
    }

    const player = g.player;
    player.blocking = gestureRef.current.blocking;

    // Decrease invulnerability
    if (player.invulnerable > 0) {
      player.invulnerable -= dt;
    }

    // Energy system
    if (gestureRef.current.bothHandsExtended && player.energy >= player.maxEnergy) {
      player.superPunchReady = true;
    }

    const { leftPunch, rightPunch, leftPunchSpeed, rightPunchSpeed } = gestureRef.current;
    const dt_factor = dt / 16.6;

    // Update powerups
    for (let i = g.powerups.length - 1; i >= 0; i--) {
      const powerup = g.powerups[i];
      powerup.x -= 2 * dt_factor;
      powerup.rotation += 0.05;
      powerup.bobOffset += 0.05;

      // Check collision with player
      const dx = powerup.x - player.x;
      const dy = powerup.y - player.y;
      const dist = Math.sqrt(dx * dx + dy * dy);

      if (dist < 60) {
        // Apply powerup effect
        if (powerup.effect === "heal") {
          player.health = Math.min(player.health + 30, player.maxHealth);
          setHealth(player.health);
        } else if (powerup.effect === "energy") {
          player.energy = Math.min(player.energy + 50, player.maxEnergy);
          setEnergy(player.energy);
        } else if (powerup.effect === "shield") {
          player.invulnerable = 5000; // 5 seconds
        }
        g.powerups.splice(i, 1);
        continue;
      }

      // Remove if off screen
      if (powerup.x < -50) {
        g.powerups.splice(i, 1);
      }
    }

    // Update enemies
    for (let i = g.enemies.length - 1; i >= 0; i--) {
      const enemy = g.enemies[i];

      if (enemy.isDying) {
        enemy.deathTimer -= dt;
        if (enemy.deathTimer <= 0) {
          g.enemies.splice(i, 1);
        }
        continue;
      }

      if (enemy.stunned > 0) {
        enemy.stunned -= dt;
        continue;
      }

      const targetX = player.x + 50;

      if (enemy.x > targetX) {
        enemy.x -= enemy.speed * dt_factor;
      } else {
        enemy.attackCooldown -= dt;
        if (enemy.attackCooldown <= 0) {
          if (!player.blocking && player.invulnerable <= 0) {
            player.health -= enemy.damage;
            setHealth(Math.max(0, player.health));
            triggerShake(10, 200);

            if (player.health <= 0) {
              runningRef.current = false;
              setRunning(false);
              g.gameOver = true;
              setStatus("💀 K.O. - Click Start to try again!");
            }
          } else {
            createBlockEffect(player.x, player.y);
            triggerShake(5, 100);
          }
          enemy.attackCooldown = 1500;
        }
      }

      const punchDist = 150;

      // Check for super punch
      if (player.superPunchReady && gestureRef.current.bothHandsExtended) {
        if (
          Math.abs(enemy.y - player.y) < enemy.size * 2 &&
          enemy.x < player.x + punchDist * 1.5 &&
          enemy.x > player.x
        ) {
          const damage = 50;
          enemy.health -= damage;
          enemy.stunned = 500;
          createPunchEffect(enemy.x, enemy.y, damage, true);
          triggerShake(15, 300);
          player.superPunchReady = false;
          player.energy = 0;
          setEnergy(0);

          if (enemy.health <= 0) {
            handleEnemyDefeat(enemy, i);
          }
        }
      }

      // Regular punch
      if (
        (leftPunch || rightPunch) &&
        Math.abs(enemy.y - player.y) < enemy.size * 1.5 &&
        enemy.x < player.x + punchDist &&
        enemy.x > player.x
      ) {
        const speed = leftPunch ? leftPunchSpeed : rightPunchSpeed;
        const damage = Math.max(1, Math.ceil(speed / 3));

        enemy.health -= damage;
        enemy.stunned = 200;
        createPunchEffect(enemy.x, enemy.y, damage);
        triggerShake(3, 100);

        // Build energy
        player.energy = Math.min(player.energy + 5, player.maxEnergy);
        setEnergy(player.energy);

        if (enemy.health <= 0) {
          handleEnemyDefeat(enemy, i);
        }
      }
    }

    // Update particles
    for (let i = g.particles.length - 1; i >= 0; i--) {
      const p = g.particles[i];
      p.x += p.vx;
      p.y += p.vy;
      p.vy += 0.2; // Gravity
      p.life -= 0.02;
      if (p.life <= 0) {
        g.particles.splice(i, 1);
      }
    }

    // Update punch text
    for (let i = g.punches.length - 1; i >= 0; i--) {
      const punch = g.punches[i];
      punch.y -= 1.5;
      punch.life -= 1;
      punch.alpha = punch.life / 60;
      if (punch.life <= 0) {
        g.punches.splice(i, 1);
      }
    }
  }

  function handleEnemyDefeat(enemy, index) {
    const g = gameRef.current;
    
    setScore((s) => {
      const newScore = s + enemy.points * (g.combo + 1);
      const newLevel = Math.floor(newScore / 100) + 1;
      if (newLevel > level) {
        setLevel(newLevel);
      }
      return newScore;
    });

    g.combo++;
    g.comboTimer = 2000;
    setCombo(g.combo);

    // Death animation
    enemy.isDying = true;
    enemy.deathTimer = 500;

    // Create death particles
    for (let i = 0; i < 15; i++) {
      const angle = (Math.PI * 2 * i) / 15;
      g.particles.push({
        x: enemy.x,
        y: enemy.y,
        vx: Math.cos(angle) * 6,
        vy: Math.sin(angle) * 6,
        size: 5,
        color: enemy.glow,
        life: 1,
      });
    }
  }

  function drawPlayer(ctx) {
    const player = gameRef.current.player;

    // Invulnerability shield
    if (player.invulnerable > 0) {
      ctx.strokeStyle = "#4ecdc4";
      ctx.lineWidth = 4;
      ctx.setLineDash([5, 5]);
      ctx.beginPath();
      ctx.arc(player.x, player.y, 70, 0, Math.PI * 2);
      ctx.stroke();
      ctx.setLineDash([]);
    }

    // Player glow
    const playerColor = player.blocking ? "#4ECDC4" : player.superPunchReady ? "#FFD700" : "#7ee787";
    ctx.shadowColor = playerColor;
    ctx.shadowBlur = 20;

    // Player body
    ctx.fillStyle = playerColor;
    ctx.beginPath();
    ctx.arc(player.x, player.y, 40, 0, Math.PI * 2);
    ctx.fill();

    ctx.shadowBlur = 0;

    // Eyes
    ctx.fillStyle = "#000";
    ctx.beginPath();
    ctx.arc(player.x - 10, player.y - 10, 5, 0, Math.PI * 2);
    ctx.arc(player.x + 10, player.y - 10, 5, 0, Math.PI * 2);
    ctx.fill();

    // Block indicator
    if (player.blocking) {
      ctx.strokeStyle = "#4ECDC4";
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.arc(player.x, player.y, 60, 0, Math.PI * 2);
      ctx.stroke();
    }

    // Super punch indicator
    if (player.superPunchReady) {
      ctx.strokeStyle = "#FFD700";
      ctx.lineWidth = 5;
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.arc(player.x, player.y, 60 + i * 10, 0, Math.PI * 2);
        ctx.globalAlpha = 0.5 - i * 0.15;
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    }

    // Health bar
    const barWidth = 80;
    const barHeight = 8;
    ctx.fillStyle = "#333";
    ctx.fillRect(player.x - barWidth / 2, player.y - 60, barWidth, barHeight);
    ctx.fillStyle =
      player.health > 50 ? "#4ade80" : player.health > 25 ? "#fbbf24" : "#f87171";
    ctx.fillRect(
      player.x - barWidth / 2,
      player.y - 60,
      (barWidth * player.health) / player.maxHealth,
      barHeight
    );
  }

  function drawEnemy(ctx, enemy) {
    if (enemy.isDying) {
      ctx.globalAlpha = enemy.deathTimer / 500;
    }

    const relativeX = CANVAS_W - enemy.x;
    const maxRelativeX = CANVAS_W - gameRef.current.player.x;
    const scaleFactor = 0.5 + 0.5 * (relativeX / maxRelativeX);

    const scaledSize = enemy.size * scaleFactor;

    // Enemy glow
    ctx.shadowColor = enemy.glow;
    ctx.shadowBlur = 15;

    // Stun effect
    if (enemy.stunned > 0) {
      ctx.fillStyle = "rgba(255, 255, 0, 0.3)";
      ctx.beginPath();
      ctx.arc(enemy.x, enemy.y, scaledSize + 10, 0, Math.PI * 2);
      ctx.fill();
    }

    // Enemy body
    ctx.fillStyle = enemy.color;
    ctx.beginPath();
    ctx.arc(enemy.x, enemy.y, scaledSize, 0, Math.PI * 2);
    ctx.fill();

    ctx.shadowBlur = 0;

    // Eyes
    ctx.fillStyle = "#000";
    ctx.beginPath();
    ctx.arc(
      enemy.x - scaledSize / 3,
      enemy.y - scaledSize / 4,
      5 * scaleFactor,
      0,
      Math.PI * 2
    );
    ctx.arc(
      enemy.x + scaledSize / 3,
      enemy.y - scaledSize / 4,
      5 * scaleFactor,
      0,
      Math.PI * 2
    );
    ctx.fill();

    // Angry mouth
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 3 * scaleFactor;
    ctx.beginPath();
    ctx.arc(enemy.x, enemy.y + scaledSize / 6, scaledSize / 4, 0, Math.PI);
    ctx.stroke();

    // Health bar
    const barWidth = enemy.size * 1.5 * scaleFactor;
    const barHeight = 6 * scaleFactor;
    const barY = enemy.y - scaledSize - 15;
    
    ctx.fillStyle = "#333";
    ctx.fillRect(enemy.x - barWidth / 2, barY, barWidth, barHeight);
    ctx.fillStyle = "#f87171";
    ctx.fillRect(
      enemy.x - barWidth / 2,
      barY,
      (barWidth * enemy.health) / enemy.maxHealth,
      barHeight
    );

    // Enemy name
    ctx.fillStyle = "#fff";
    ctx.font = `${10 * scaleFactor}px Arial`;
    ctx.textAlign = "center";
    ctx.fillText(enemy.name, enemy.x, barY - 8);

    ctx.globalAlpha = 1;
  }

  function drawPowerup(ctx, powerup) {
    const bobAmount = Math.sin(powerup.bobOffset) * 5;

    ctx.save();
    ctx.translate(powerup.x, powerup.y + bobAmount);
    ctx.rotate(powerup.rotation);

    // Glow
    ctx.shadowColor = powerup.color;
    ctx.shadowBlur = 20;

    // Circle
    ctx.fillStyle = powerup.color;
    ctx.beginPath();
    ctx.arc(0, 0, powerup.size, 0, Math.PI * 2);
    ctx.fill();

    ctx.shadowBlur = 0;

    // Emoji
    ctx.font = `${powerup.size}px Arial`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(powerup.emoji, 0, 0);

    ctx.restore();
  }

  function draw() {
    const ctx = gameCanvasRef.current?.getContext("2d");
    if (!ctx) return;

    ctx.save();
    ctx.translate(gameRef.current.shake.x, gameRef.current.shake.y);

    drawBackground(ctx);

    const g = gameRef.current;
    const ges = gestureRef.current;

    // Draw particles
    g.particles.forEach((p) => {
      ctx.fillStyle = p.color;
      ctx.globalAlpha = p.life;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = 1;
    });

    // Draw damage numbers
    g.punches.forEach((punch) => {
      ctx.fillStyle = punch.color;
      ctx.globalAlpha = punch.alpha;
      ctx.font = `bold ${punch.size}px Arial`;
      ctx.textAlign = "center";
      ctx.strokeStyle = "#000";
      ctx.lineWidth = 3;
      ctx.strokeText(punch.text, punch.x, punch.y);
      ctx.fillText(punch.text, punch.x, punch.y);
      ctx.globalAlpha = 1;
    });

    // Draw powerups
    g.powerups.forEach((powerup) => drawPowerup(ctx, powerup));

    // Draw enemies and player
    g.enemies.forEach((enemy) => drawEnemy(ctx, enemy));
    drawPlayer(ctx);

    // HUD
    if (runningRef.current) {
      const timeRemaining = Math.max(0, (g.timeLimit - g.time) / 1000);
      ctx.fillStyle = timeRemaining < 10 ? "#f87171" : "#FFD700";
      ctx.font = "bold 32px Arial";
      ctx.textAlign = "right";
      ctx.strokeStyle = "#000";
      ctx.lineWidth = 4;
      ctx.strokeText(`⏱️ ${timeRemaining.toFixed(1)}s`, CANVAS_W - 20, 45);
      ctx.fillText(`⏱️ ${timeRemaining.toFixed(1)}s`, CANVAS_W - 20, 45);

      // Wave indicator
      ctx.textAlign = "left";
      ctx.fillStyle = "#4ecdc4";
      ctx.strokeText(`🌊 Wave ${g.wave}`, 20, 45);
      ctx.fillText(`🌊 Wave ${g.wave}`, 20, 45);
    }

    // Hand position indicators
    if (ges.leftHandPos) {
      ctx.fillStyle = "rgba(126, 231, 135, 0.6)";
      ctx.strokeStyle = "#7ee787";
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.arc(ges.leftHandPos.x, ges.leftHandPos.y, 20, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
    }
    if (ges.rightHandPos) {
      ctx.fillStyle = "rgba(78, 205, 196, 0.6)";
      ctx.strokeStyle = "#4ecdc4";
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.arc(ges.rightHandPos.x, ges.rightHandPos.y, 20, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
    }

    // Game Over / Win Screens
    if (g.gameOver) {
      ctx.fillStyle = "rgba(0, 0, 0, 0.85)";
      ctx.fillRect(0, 0, CANVAS_W, CANVAS_H);

      ctx.fillStyle = "#f87171";
      ctx.font = "bold 80px Arial";
      ctx.textAlign = "center";
      ctx.strokeStyle = "#000";
      ctx.lineWidth = 6;
      ctx.strokeText("K.O.!", CANVAS_W / 2, CANVAS_H / 3);
      ctx.fillText("K.O.!", CANVAS_W / 2, CANVAS_H / 3);

      ctx.fillStyle = "#fff";
      ctx.font = "36px Arial";
      ctx.strokeText(`Final Score: ${score}`, CANVAS_W / 2, CANVAS_H / 2);
      ctx.fillText(`Final Score: ${score}`, CANVAS_W / 2, CANVAS_H / 2);
      
      ctx.font = "24px Arial";
      ctx.fillText("Click Start to fight again", CANVAS_W / 2, CANVAS_H / 2 + 60);
    } else if (g.gameWin) {
      ctx.fillStyle = "rgba(26, 26, 46, 0.9)";
      ctx.fillRect(0, 0, CANVAS_W, CANVAS_H);

      ctx.fillStyle = "#FFD700";
      ctx.font = "bold 80px Arial";
      ctx.textAlign = "center";
      ctx.strokeStyle = "#000";
      ctx.lineWidth = 6;
      ctx.strokeText("🏆 VICTORY! 🏆", CANVAS_W / 2, CANVAS_H / 3);
      ctx.fillText("🏆 VICTORY! 🏆", CANVAS_W / 2, CANVAS_H / 3);

      ctx.fillStyle = "#4ade80";
      ctx.font = "36px Arial";
      ctx.strokeText(`Champion Score: ${score}`, CANVAS_W / 2, CANVAS_H / 2);
      ctx.fillText(`Champion Score: ${score}`, CANVAS_W / 2, CANVAS_H / 2);
      
      ctx.fillStyle = "#fff";
      ctx.font = "24px Arial";
      ctx.fillText("You survived the arena!", CANVAS_W / 2, CANVAS_H / 2 + 60);
    }

    ctx.restore();
  }

  function gameLoop(time) {
    const dt = time - (gameLoop.last || time);
    gameLoop.last = time;

    if (videoRef.current && videoRef.current.readyState >= 2) {
      detectHandGestures(videoRef.current);
    }

    drawCameraPreview();

    if (runningRef.current) {
      step(dt);
    }

    draw();

    if (runningRef.current || gameRef.current.gameOver || gameRef.current.gameWin) {
      rafRef.current = requestAnimationFrame(gameLoop);
    }
  }

  function drawCameraPreview() {
    if (!camCanvasRef.current || !videoRef.current || videoRef.current.readyState < 2) {
      return;
    }

    try {
      const ctx = camCanvasRef.current.getContext("2d");
      ctx.fillStyle = "#000";
      ctx.fillRect(0, 0, CAM_W, CAM_H);

      ctx.save();
      ctx.scale(-1, 1);
      ctx.drawImage(videoRef.current, -CAM_W, 0, CAM_W, CAM_H);
      ctx.restore();

      const ges = gestureRef.current;

      if (ges.leftHandPos) {
        const mirroredX = CAM_W - (ges.leftHandPos.x / CANVAS_W) * CAM_W;
        const y = (ges.leftHandPos.y / CANVAS_H) * CAM_H;

        ctx.fillStyle = "rgba(126, 231, 135, 0.6)";
        ctx.beginPath();
        ctx.arc(mirroredX, y, 10, 0, Math.PI * 2);
        ctx.fill();
      }

      if (ges.rightHandPos) {
        const mirroredX = CAM_W - (ges.rightHandPos.x / CANVAS_W) * CAM_W;
        const y = (ges.rightHandPos.y / CANVAS_H) * CAM_H;

        ctx.fillStyle = "rgba(78, 205, 196, 0.6)";
        ctx.beginPath();
        ctx.arc(mirroredX, y, 10, 0, Math.PI * 2);
        ctx.fill();
      }

      if (ges.blocking) {
        ctx.strokeStyle = "rgba(78, 205, 196, 1)";
        ctx.lineWidth = 4;
        ctx.strokeRect(0, 0, CAM_W, CAM_H);
      }

      if (gameRef.current.player.superPunchReady) {
        ctx.strokeStyle = "rgba(255, 215, 0, 1)";
        ctx.lineWidth = 4;
        ctx.strokeRect(0, 0, CAM_W, CAM_H);
      }
    } catch (e) {
      console.error("Error drawing camera preview:", e);
    }
  }

  function resetGameState() {
    setScore(0);
    setHealth(100);
    setLevel(1);
    setCombo(0);
    setEnergy(0);

    initializeStars();

    gameRef.current = {
      width: CANVAS_W,
      height: CANVAS_H,
      player: {
        x: 150,
        y: CANVAS_H * 0.7,
        health: 100,
        maxHealth: 100,
        blocking: false,
        energy: 0,
        maxEnergy: 100,
        superPunchReady: false,
        invulnerable: 0,
      },
      enemies: [],
      particles: [],
      punches: [],
      powerups: [],
      lastEnemySpawn: 0,
      lastPowerupSpawn: 0,
      time: 0,
      timeLimit: GAME_TIME_LIMIT,
      shake: { x: 0, y: 0, intensity: 0, duration: 0 },
      gameOver: false,
      gameWin: false,
      combo: 0,
      comboTimer: 0,
      stars: gameRef.current.stars,
      wave: 1,
      enemiesThisWave: 0,
      maxEnemiesPerWave: 5,
    };
    drawInitialState();
  }

  async function startGame() {
    if (runningRef.current) return;

    resetGameState();
    setStatus("Requesting camera access...");

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 640 },
          height: { ideal: 480 },
          facingMode: "user",
        },
      });

      streamRef.current = stream;
      setStatus("Camera acquired...");

      if (!videoRef.current) {
        videoRef.current = document.createElement("video");
      }

      videoRef.current.playsInline = true;
      videoRef.current.muted = true;
      videoRef.current.autoplay = true;
      videoRef.current.srcObject = stream;

      await new Promise((resolve) => {
        const checkReady = () => {
          if (videoRef.current.readyState >= 2) {
            resolve();
          }
        };
        videoRef.current.addEventListener("loadeddata", checkReady);
        setTimeout(resolve, 5000);
      });

      try {
        await videoRef.current.play();
      } catch (e) {
        console.log("Play error:", e);
      }

      await new Promise((resolve) => setTimeout(resolve, 500));

      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }

      runningRef.current = true;
      setRunning(true);

      gameLoop.last = performance.now();
      rafRef.current = requestAnimationFrame(gameLoop);

      setStatus("🥊 Fight! Show your skills!");
    } catch (e) {
      console.error("Camera error:", e);
      setStatus(`Camera error: ${e.message}`);
    }
  }

  function stopGame() {
    runningRef.current = false;
    setRunning(false);

    if (rafRef.current) {
      cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
    }

    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }

    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }

    setStatus("Stopped – Click Start");
    drawInitialState();
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#0a0e27" }}>
      <div style={{ width: 340, background: "#1a1a2e", padding: 20, color: "#fff", boxShadow: "4px 0 20px rgba(0,0,0,0.5)" }}>
        <Title level={3} style={{ color: "#FFD700", marginTop: 0, textShadow: "0 0 10px #FFD700" }}>
          🥊 Shadow Boxing Arena
        </Title>

        <Text
          style={{
            color: "#e6eef8",
            marginBottom: 12,
            fontSize: 14,
            fontWeight: "bold",
            display: "block",
          }}
        >
          {status}
        </Text>

        <Divider style={{ margin: "16px 0", borderColor: "rgba(255,255,255,0.2)" }} />

        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
          <Button
            onClick={startGame}
            disabled={running}
            type="primary"
            block
            size="large"
            style={{
              fontWeight: "bold",
              background: running ? "#555" : "linear-gradient(135deg, #e94560 0%, #ff6b6b 100%)",
              borderColor: running ? "#555" : "#e94560",
              height: 48,
            }}
          >
            {running ? "⚔️ FIGHTING..." : "⚔️ START FIGHT"}
          </Button>
          <Button
            onClick={stopGame}
            disabled={!running}
            danger
            block
            size="large"
            style={{ height: 40 }}
          >
            Stop Fight
          </Button>
        </div>

        <div style={{ marginBottom: 20, background: "rgba(0,0,0,0.3)", padding: 12, borderRadius: 8 }}>
          <Text style={{ color: "#FFD700", fontSize: 28, fontWeight: "bold", display: "block" }}>
            💰 {score}
          </Text>
          
          <div style={{ marginTop: 12 }}>
            <Text style={{ color: "#fff", fontSize: 13, fontWeight: "bold" }}>Health:</Text>
            <Progress
              percent={health}
              strokeColor={{
                '0%': health > 50 ? '#4ade80' : health > 25 ? '#fbbf24' : '#f87171',
                '100%': health > 50 ? '#22c55e' : health > 25 ? '#f59e0b' : '#ef4444',
              }}
              showInfo={false}
              style={{ marginTop: 6 }}
              strokeWidth={12}
            />
          </div>

          <div style={{ marginTop: 12 }}>
            <Text style={{ color: "#FFD700", fontSize: 13, fontWeight: "bold" }}>Energy (Super Punch):</Text>
            <Progress
              percent={energy}
              strokeColor={{
                '0%': '#FFD700',
                '100%': '#FFA500',
              }}
              showInfo={false}
              style={{ marginTop: 6 }}
              strokeWidth={12}
            />
            {energy >= 100 && (
              <Text style={{ color: "#FFD700", fontSize: 11, display: "block", marginTop: 4 }}>
                ⚡ SUPER PUNCH READY! Extend both hands forward!
              </Text>
            )}
          </div>

          <div style={{ marginTop: 12, display: "flex", justifyContent: "space-between" }}>
            <Text style={{ color: "#4ecdc4", fontSize: 20, fontWeight: "bold" }}>
              🌊 Wave {gameRef.current.wave}
            </Text>
            <Text style={{ color: "#ff6b6b", fontSize: 20, fontWeight: "bold" }}>
              🔥 {combo}x Combo
            </Text>
          </div>
        </div>

        <Divider style={{ margin: "16px 0", borderColor: "rgba(255,255,255,0.2)" }} />

        <div style={{ color: "#bfe7ff", fontSize: 12, marginBottom: 14, lineHeight: 1.7 }}>
          <Title level={5} style={{ color: "#4ecdc4", marginTop: 0, marginBottom: 10 }}>
            🎮 Controls:
          </Title>
          <Text style={{ color: "#bfe7ff", display: "block", marginBottom: 4 }}>
            👊 <strong>Punch Forward</strong> - Attack enemies
          </Text>
          <Text style={{ color: "#bfe7ff", display: "block", marginBottom: 4 }}>
            🙌 <strong>Raise Both Hands High</strong> - Block attacks
          </Text>
          <Text style={{ color: "#bfe7ff", display: "block", marginBottom: 4 }}>
            ⚡ <strong>Extend Both Hands Forward</strong> - Super Punch (when charged)
          </Text>
          <Text style={{ color: "#FFD700", display: "block", marginTop: 8, fontSize: 11 }}>
            💡 Faster punches = More damage!
          </Text>
          <Text style={{ color: "#4ade80", display: "block", fontSize: 11 }}>
            💡 Collect powerups for health, energy & shields!
          </Text>
        </div>

        <Divider style={{ margin: "16px 0", borderColor: "rgba(255,255,255,0.2)" }} />

        <Text
          style={{
            marginBottom: 8,
            color: "#999",
            fontSize: 11,
            fontWeight: "bold",
            display: "block",
          }}
        >
          Camera Preview:
        </Text>
        <canvas
          ref={camCanvasRef}
          width={CAM_W}
          height={CAM_H}
          style={{
            borderRadius: 8,
            width: "100%",
            background: "#000",
            border: gestureRef.current.blocking ? "3px solid #4ecdc4" : 
                    gameRef.current.player.superPunchReady ? "3px solid #FFD700" : 
                    "2px solid #333",
          }}
        />
      </div>

      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0a0e27",
        }}
      >
        <canvas
          ref={gameCanvasRef}
          width={CANVAS_W}
          height={CANVAS_H}
          style={{ 
            borderRadius: 12, 
            boxShadow: "0 10px 50px rgba(0,0,0,0.8)",
            border: "2px solid rgba(255, 215, 0, 0.3)"
          }}
        />
      </div>
    </div>
  );
}